export const desktopsManifestPrivateSymbol = Symbol();
